<template>
  <svg
    viewBox="0 0 96 96"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m82.52 37.87c-1.26.31-2.53 1.42-3.79 1.33a34.16 34.16 0 1 1 -2.52-4.38 30.26 30.26 0 0 1 4.08-1.08 38.41 38.41 0 1 0 2.23 4.13z"
      fill="#4f2b1b"
    />
    <rect
      fill="#85c441"
      height="23"
      rx="11.04"
      width="54.28"
      x="41.72"
      y="73"
    />
    <path
      d="m22.35 49.57a52.84 52.84 0 0 1 4.95 3.07 51.33 51.33 0 0 1 4.61 3.59 44.19 44.19 0 0 1 3.93 4.35 25.46 25.46 0 0 1 3.22 5.28l-4.93-.71c2.67-2.74 5.51-5.57 8.4-8.16a110.54 110.54 0 0 1 9.1-7.37 103.28 103.28 0 0 1 9.83-6.26 88.62 88.62 0 0 1 10.47-4.86l.19.32a89.49 89.49 0 0 0 -9.68 6.09 103.36 103.36 0 0 0 -8.8 7.2c-2.77 2.58-5.44 5.24-8 8-1.22 1.44-2.44 2.89-3.64 4.34s-2.25 2.93-3.39 4.55l-2.45 3.48-2.49-4.19a47.6 47.6 0 0 0 -2.55-4.37c-1-1.49-1.93-3-3-4.54-.5-.77-1-1.59-1.43-2.4s-1-1.62-1.45-2.42c-1-1.63-2-3.23-3-4.87z"
      fill="#4f2b1b"
    />
    <path
      d="m80.34 46.71c-1.21-2.49-4.6-4.92-7.33-4.77a7.49 7.49 0 0 0 -4.55 2.36 50.55 50.55 0 0 1 11 4.74c-2-1.33-6.31-2.51-9.24-3.23a15.65 15.65 0 0 0 -1.84-.5l-.57-.07-4.81-.62-1.34 1a22 22 0 0 1 6 .37 4.24 4.24 0 0 0 3.5 5c4.84 1.11 10.84-.53 10.84-.53s.84 1.39-1.66-3.75z"
      fill="#85c441"
    />
    <path
      d="m84.59 33.4c-2.25-1.61-6.39-2.12-8.72-.68a7.51 7.51 0 0 0 -2.87 4.28 49.58 49.58 0 0 1 12-1.12c-2.39-.21-6.74.82-9.66 1.58a14.17 14.17 0 0 0 -1.85.45l-.54.2c-1.65.63-4.49 1.75-4.49 1.75l-.69 1.53a22.17 22.17 0 0 1 5.45-2.55 4.24 4.24 0 0 0 5.44 2.68c4.79-1.32 9.26-5.62 9.26-5.62s1.33.82-3.33-2.5z"
      fill="#85c441"
    />
    <path
      d="m71.11 54.52c-1.21-2.49-4.6-4.92-7.33-4.77a7.46 7.46 0 0 0 -4.55 2.36 49.6 49.6 0 0 1 11 4.74c-2-1.33-6.31-2.51-9.24-3.23a16.2 16.2 0 0 0 -1.84-.5l-.55-.12-4.78-.61-1.34 1a22.21 22.21 0 0 1 6 .36 4.25 4.25 0 0 0 3.5 5c4.84 1.13 10.82-.5 10.82-.5s.81 1.41-1.69-3.73z"
      fill="#85c441"
    />
    <path
      d="m62.83 63c-1.21-2.49-4.6-4.92-7.33-4.77a7.42 7.42 0 0 0 -4.5 2.36 50 50 0 0 1 11 4.73c-2-1.32-6.31-2.51-9.24-3.23a16.78 16.78 0 0 0 -1.84-.5l-.57-.07c-1.76-.24-4.78-.62-4.78-.62l-1.34 1a22 22 0 0 1 6 .37 4.24 4.24 0 0 0 3.5 4.95c4.84 1.14 10.82-.5 10.82-.5s.78 1.41-1.72-3.72z"
      fill="#85c441"
    />
    <path
      d="m62.59 40.92c.7-1 2.28-3.53 1.86-5.93-.45-2.58-3.9-4.92-6.27-5.69-5.17-1.67-3.74-1.07-3.74-1.07s-.32 6.19 1.67 10.77c1.35 3.15 3.71 3.08 5.08 2.72a6.53 6.53 0 0 1 -.19 1.79c.94-.67 1.07-.58 1.07-.58s-.07-.6-.21-1.41a20.76 20.76 0 0 0 -4.53-10.34c4 3.09 5.01 7.94 5.26 9.74z"
      fill="#85c441"
    />
    <path
      d="m52.54 46.13c.7-1 2.28-3.53 1.86-5.93-.45-2.59-3.9-4.93-6.27-5.69-5.17-1.67-3.74-1.08-3.74-1.08s-.32 6.19 1.67 10.81c1.35 3.14 3.69 3.09 5.06 2.73a15.09 15.09 0 0 1 -.16 3.1c.94-.67 1.3-1 1.3-1s-.14-1.08-.4-2.36a20.83 20.83 0 0 0 -4.53-10.34c3.95 3.1 4.96 7.96 5.21 9.76z"
      fill="#85c441"
    />
    <path
      d="m44.22 52.87c.7-1 2.27-3.53 1.85-5.93-.44-2.58-3.89-4.92-6.26-5.69-5.17-1.67-3.75-1.07-3.75-1.07s-.31 6.19 1.67 10.82c1.35 3.14 3.7 3.09 5.07 2.73a14.9 14.9 0 0 1 -.16 3.15 13.52 13.52 0 0 1 1.3-1.17s-.15-1.13-.42-2.43a20.84 20.84 0 0 0 -4.52-10.15c4 3.09 5 7.94 5.22 9.74z"
      fill="#85c441"
    />
    <g fill="#fff">
      <path
        d="m51 85.93a4.22 4.22 0 0 0 -1.49-.05v2.7c0 .09-.2.14-.27.14a.28.28 0 0 1 -.28-.21l-.12-7.4c0-.21 0-.39.27-.39.05 0 .38 0 .38.14v4.45c.39 0 1.22 0 1.56.07v-.44c0-1.42-.09-2.65-.09-3.89 0-.12 0-.33.18-.33s.38.07.4.27l.14 7.47a.34.34 0 0 1 -.35.32h-.06c-.07 0-.18-.2-.2-.27a20.31 20.31 0 0 0 -.07-2.58z"
      />
      <path
        d="m53.25 81.32.46 6.35a5.35 5.35 0 0 1 0 .55c0 .17-.17.23-.35.23s-.27-.2-.3-.4l-.26-4.56c-.05-.75-.17-1.5-.15-2.25.06-.24.58-.17.6.08z"
      />
      <path
        d="m54.81 84.55c0-.82.18-2.42 1.09-2.85.52-.25 1.87-.15 1.87.68 0 .13-.05.26-.23.26-.37 0-.51-.56-1-.56-1 0-1.13 1.51-1.13 2.29v.21a15 15 0 0 0 .27 2.79c.1.49.38 1 1 1 .94 0 1-1.29.94-1.89l-.12-1.48a9.09 9.09 0 0 1 -.93.06c-.1-.07-.13-.33-.13-.34 0-.31.72-.25 1.39-.26.32.09.28.61.31 1.25v.11c.06 1.13.15 3.06-1.36 3.13h-.2c-1.41.05-1.77-1.69-1.77-4.4z"
      />
      <path
        d="m61.38 85.93a4.29 4.29 0 0 0 -1.5-.05v2.7c0 .09-.2.14-.26.14a.26.26 0 0 1 -.28-.21l-.13-7.4c0-.21 0-.39.27-.39.05 0 .38 0 .38.14v4.45c.38 0 1.21 0 1.55.07v-.44c0-1.42-.09-2.65-.09-3.89 0-.12 0-.33.18-.33s.39.07.41.27l.13 7.47a.33.33 0 0 1 -.35.32h-.05c-.08 0-.19-.2-.21-.27a22.33 22.33 0 0 0 -.05-2.58z"
      />
      <path
        d="m66.78 81.32.46 6.35a5.35 5.35 0 0 1 .05.55c0 .17-.18.23-.35.23s-.27-.2-.31-.4l-.25-4.56a21.25 21.25 0 0 1 -.15-2.25c.01-.24.53-.17.55.08z"
      />
      <path
        d="m68.59 81.34c.2-.37.5 0 .61.11.62 1.79 1 3.61 1.81 5.47l.1-1.46a36.14 36.14 0 0 0 .12-3.75.38.38 0 0 1 .39-.26.3.3 0 0 1 .29.13c-.18 2.25-.27 4.64-.34 7v.13s-.16.2-.25.2a.46.46 0 0 1 -.29-.2c-.65-1.94-1.38-3.85-2-5.8l-.03 5.97c-.24.54-.61.26-.62 0z"
      />
      <path
        d="m76.28 85.13c0-1.31-.2-2.93-.2-4.14 0-.26.75-.24 1-.26s.92-.16.92.38c0 0 0 .16-1.43.16l.14 2h.94c.16 0 .27.21.27.33 0 .28-.9.17-1.18.21v.6c.07 1.5.06 1.94.06 3.44a.24.24 0 0 1 -.24.26c-.09 0-.26 0-.3-.14.08-.56.04-2.26.02-2.84z"
      />
      <path
        d="m79.65 81.32.46 6.35a5.35 5.35 0 0 1 0 .55c0 .17-.18.23-.35.23s-.27-.2-.31-.4l-.25-4.56a21.25 21.25 0 0 1 -.15-2.25c.06-.24.58-.17.6.08z"
      />
      <path
        d="m81.26 81.53a3.26 3.26 0 0 1 -.06-.72c0-.18.22-.29.4-.28 1 .06 1.87.48 1.87 1.56a1.27 1.27 0 0 1 -.6 1.3c1.35.61 1.72 2.07 1.72 3.46a2.28 2.28 0 0 1 -1.8 2.15l-.26.06a.88.88 0 0 1 -.67-.06c-.41-.26-.43-6.53-.6-7.47zm.55 1v.59h.19a.86.86 0 0 0 .84-.92 1 1 0 0 0 -1.08-1.09c.03.23.03 1.21.05 1.42zm.12 1.6c.08 1.56.2 2.88.27 4.38h.06a1.64 1.64 0 0 0 1.74-1.84c0-1.37-.5-2.91-2.08-2.91 0 .05.01.32.01.37z"
      />
      <path
        d="m85.38 87.65v-2.06c0-1.49-.15-2.45-.15-3.93v-.54c1.67-.13 1.85 0 1.85.21 0 .08 0 .23-.12.26h-1.13c-.08 0-.08 0-.08.09 0 1.1.11 1.91.17 3a9.71 9.71 0 0 0 1.21 0c.35 0 .59.61.11.61h-1.32v2.43c.25.07 1.57-.19 1.57.26a.26.26 0 0 1 -.2.28c-.38 0-1.86.14-1.87-.16z"
      />
      <path
        d="m88.7 84.57c0-.32 0-2.22-.07-2.71 0-.1-.07-1-.08-1.13 0-.24.27-.3.48-.3 1.44 0 2 1 2 2.22a2.27 2.27 0 0 1 -1 2c1.19.53 1.49 2.23 1.49 3.39 0 .19-.12.26-.31.26s-.17 0-.22-.16c-.06-.78-.25-3-1.46-3h-.11c-.11 1.18 0 2.36-.09 3.55a.33.33 0 0 1 -.55 0c-.07-.62-.07-3.5-.08-4.12zm.57-.25a1.63 1.63 0 0 0 1.15-1.61c0-.56-.23-1.7-1-1.7 0 0-.37 0-.37.08z"
      />
    </g>
  </svg>
</template>
